import React, { useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Navigation from "../Navigation/Navigation";
import { MdKeyboardArrowLeft, MdEast } from "react-icons/md";
import ActiveCoupons from "./ActiveCoupons";
import RedeemedCoupons from "./RedeemedCoupons";
import { CouponsApi } from "../../Utils/Api/CouponsApi";
import Loader from "../../Components/Loader/Loader";
import { Link, useNavigate } from "react-router-dom";

const MyCoupons = () => {
  const [couponsData, setCouponsData] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const CouponsHandler = async () => {
    setLoading(true);
    const activecoupons = await CouponsApi(() => {
      navigate("/");
    });
    setLoading(false);
    setCouponsData(activecoupons.coupons_list);
  };

  useEffect(() => {
    CouponsHandler();
  }, []);
  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to="/">
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>
          <p className="page-maintitle">My Coupons</p>
          <Tabs
            defaultActiveKey="active"
            id="uncontrolled-tab-example"
            className="mb-3 vou-tab mt-3"
          >
            <Tab eventKey="active" title="Active Coupons">
              <ActiveCoupons coupons={couponsData} />
            </Tab>
            <Tab eventKey="redeemed" title="Used Coupons">
              <RedeemedCoupons coupons={couponsData} />
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default MyCoupons;
